import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Copyright from "../components/Copyright";
import AppBar from "../components/actionBar/AppBar";
import { GraphContext } from "../context/GraphContext";
import { WebSocketContext } from "../context/WebSocketContext";
import { DashboardContext } from "../context/DashboardContext";
import { FileHandlingContext } from "../context/FileHandlingContext";
import { GeneralContext } from "../context/GeneralContext";
import LeftSide from "../components/leftSide/LeftSide";
import RightSide from "../components/rightSide/RightSide";
import GraphContainer from "../components/middle/GraphContainer";
import "./dashboard.scss";
import {
  // getListOfTermsToUpdate,
  performChi2Message,
  updatedChi2,
} from "../components/rightSide/fit/fitLogic";
import { ReadyState } from "react-use-websocket";
import { AuthContext } from "../context/AuthContext";
import { useTutorialProgress } from "../context/TutorialContext";
import {
  checkBool,
  downloadStringTxtFile,
  generateModelsRangesQuantPairsForModelDist,
  generateWarningObject,
  getColor,
  getRangesForModelsFromGraphs,
  getReturnedCurveDictionaryByGraphId,
  hasProperty,
  isDeepEqual,
  getLayoutForWindows,
  formatParamNameToString,
  getQuantityNameFromModels,
  isInverseUnit,
  convertDataFromUnitsToUnits,
  jsxToHtmlString,
  getQuantityXUnitFromModels,
} from "../utils/helpers";
import units from "../utils/units";
import StickyFileWindow from "../components/leftSide/Files/StickyFileWindow";
import { isClickedOutside } from "../components/leftSide/Files/FileUploadLogic";
import BroadcastModal from "../components/commonComponents/BroadcastModal";
import Modal from "react-modal";
import SingleFileReprocess from "../components/leftSide/Files/fileProcessing/SingleFileReprocess";
import {
  deepCopy,
  getModelById,
  replaceModelById,
} from "../components/leftSide/Models/modelLogic";
import WindowSelector from "../components/windowSelector/WindowSelector";
import Loop from "../components/middle/loop/Loop";
import FitStopWindow from "../components/middle/FitStopWindow";
import LoopStopWindow from "../components/middle/loop/LoopStopWindow";
import {
  containedModelIDsInGraphs,
  createModelDistPayload,
} from "../components/middle/graphLogic";
import { DEFAULT_GRAPH } from "../utils/constants";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import GridViewIcon from "@mui/icons-material/GridView";
import { getAllIDsInModels } from "../components/rightSide/parameters/parameterLogic";
// import { getUpdatedUniqueIds } from "../components/rightSide/parameters/parameterLogic";

//this is the main function of the whole application
export default function Dashboard() {
  const navigate = useNavigate();
  const { selectedFiles, setSelectedFiles, updateSelected } =
    useContext(FileHandlingContext);
  const {
    chi2Terms,
    setChi2Terms,
    graphs,
    setGraphs,
    selectedChi2Terms,
    requestedFitModel,
    setRequestedFitModel,
    updatedModelFE_IDs,
    setUpdatedModelFE_IDs,
    graphId,
    setGraphId,
    setZIndices,
  } = useContext(GraphContext);
  const {
    lastJsonMessage,
    readyState,
    sendMessage,
    authSent,
    setAuthSent,
    isFitOngoing,
    isLoopOngoing,
    setIsLoopOngoing,
    setIsFitOngoing,
    retrieveRequestData,
    deleteRequestDataEntry,
    sendJsonMessage,
    clearMessage,
    lastMessage,
    setAuthConfirmed,
  } = useContext(WebSocketContext);
  const {
    fitIteration,
    setFitIteration,
    setWarnings,
    setNewWarningCount,
    modelData,
    setModelData,
    // showLeftPanel,
    // setShowLeftPanel,
    fileCallFromGraph,
    setFileCallFromGraph,
    fileToChange,
    setFileToChange,
    uploadedFiles,
    setUploadedFiles,
    setTotalActiveParams,
    chi2ReqAllowed,
    setChi2ReqAllowed,
    chi2QueRef,
    loopOpen,
    // setLoopOpen,
    outputsOpen,
    // setOutputsOpen,
    // requestedVdf,
    // setRequestedVdf,
    loopIteration,
    setLoopIteration,
    listOfLoopModelsToSave,
    listOfLoopCurvesToSave,
    loopModelFilesCustomName,
    valueGroups,
    setValueGroups,
    pauseOnNextLoop,
    setPauseOnNextLoop,
    loopPaused,
    setLoopPaused,
    trackedParameters,
    checkIfSubModTitle,
    parametersOpen,
    areParamsSorted,
    setAreParamsSorted,
    modelsZIndices,
    setModelsZIndices,
    checkParamPositions,
    setCheckParamPositions,
    paramWindowPosAndSize,
    setParamWindowPosAndSize,
  } = useContext(DashboardContext);
  const { authToken, isAuthReady, currentUser, accessLevel } =
    useContext(AuthContext);
  const { monitorStateChange } = useTutorialProgress();
  const {
    setBroadcastMessage,
    limitedToast,
    limitedWarningToast,
    limitedSucessToast,
    recordedErrorLog,
  } = useContext(GeneralContext);
  const [broadcastOpen, setBroadcastOpen] = useState(false);
  const [reprocessOpen, setReprocessOpen] = useState(false);
  const [fileToReprocess, setFileToReprocess] = useState(null);

  // We need state and ref in this case, because ref updates are not caught in StickyFileWindow immediately
  // and state change is not visible in useEffect where we have click outside logic
  const [fromGraphState, setfromGraphState] = useState(false);
  const [updateChiTerms, setUpdateChiTerms] = useState(false);
  const fromGraph = useRef(false);
  const dashboardRef = useRef();
  const updateIDWaitList = useRef([]);
  const updatePending = useRef(false);
  const requestedFitModelsLocal = useRef([]);
  const localValueGroups = useRef(valueGroups);
  const debounceTimeoutRef = useRef(null);

  useEffect(() => {
    const listOfAllModelIDs = getAllIDsInModels(modelData);

    let updatedDict = deepCopy(modelsZIndices ? modelsZIndices : {});

    for (let i = 0; i < listOfAllModelIDs.length; i++) {
      const modelID = listOfAllModelIDs[i];

      if (!hasProperty(updatedDict, modelID)) {
        updatedDict[modelID] = 0;
      }
    }

    setModelsZIndices(updatedDict);
  }, [modelData]);

  useEffect(() => {
    try {
      if (checkParamPositions) {
        const allIDs = getAllIDsInModels(modelData);
        const updatedPosAndSizes = deepCopy(paramWindowPosAndSize);
        const posSizeKeys = Object.keys(updatedPosAndSizes);
        for (let i = 0; i < posSizeKeys.length; i++) {
          const key = posSizeKeys[i];
          if (!allIDs.some((id) => id === parseInt(key))) {
            delete updatedPosAndSizes[key];
          }
        }

        const updatedModelsZIndices = deepCopy(modelsZIndices);
        const zIndicesKeys = Object.keys(updatedModelsZIndices);
        for (let i = 0; i < zIndicesKeys.length; i++) {
          const key = zIndicesKeys[i];
          if (!allIDs.some((id) => id === parseInt(key))) {
            delete updatedModelsZIndices[key];
          }
        }
        const newGridPositions = getLayoutForWindows(
          updatedPosAndSizes,
          window.innerWidth - 60
        );
        setParamWindowPosAndSize(newGridPositions);

        // if (!isDeepEqual(paramWindowPosAndSize, updatedPosAndSizes)) {
        //   setParamWindowPosAndSize(updatedPosAndSizes);
        // }

        // if (!isDeepEqual(updatedModelsZIndices, modelsZIndices)) {
        //   setModelsZIndices(updatedModelsZIndices);
        // }

        setCheckParamPositions(false);
      }
    } catch (error) {
      recordedErrorLog("Error in parameter position checking useEffect", error);
    }
  }, [checkParamPositions]);

  useEffect(() => {
    // This useEffect is used to updated Chi2 term values with relevant file and model names after
    // user has changed them
    try {
      if (chi2Terms === undefined || uploadedFiles === undefined) {
        return;
      }
      if (chi2Terms.length > 0) {
        const updatedTerms = chi2Terms.map((term) => {
          const relevantModel = getModelById(term.modelId, modelData);
          const relevantFile = uploadedFiles.find(
            (file) => file.ID === term.fileId
          );
          const newTerm = {
            ...term,
            modelName: relevantModel.displayName,
            fileName: relevantFile.name,
          };

          return newTerm;
        });

        setChi2Terms(updatedTerms);
      }
    } catch (error) {
      recordedErrorLog(
        "Error updating chi2 terms after modelData/uploadedFiles change: ",
        error,
        true,
        "Error updating chi2 terms after model or file change",
        {
          modelData: modelData,
          uploadedFiles: uploadedFiles,
          chi2Terms: chi2Terms,
        }
      );
    }
  }, [modelData, uploadedFiles]);

  useEffect(() => {
    requestedFitModelsLocal.current = requestedFitModel;
  }, [requestedFitModel]);

  useEffect(() => {
    if (!isDeepEqual(valueGroups, localValueGroups.current)) {
      localValueGroups.current = valueGroups;
    }
  }, [valueGroups]);

  // Listen for quota warning events and show toast notifications
  useEffect(() => {
    const handleQuotaWarning = (event) => {
      const { message } = event.detail;
      limitedWarningToast(message);
    };

    window.addEventListener("quotaWarning", handleQuotaWarning);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("quotaWarning", handleQuotaWarning);
    };
  }, [limitedWarningToast]);

  useEffect(() => {
    if (updatedModelFE_IDs.length > 0) {
      const idsToUpdate = containedModelIDsInGraphs(
        updatedModelFE_IDs,
        graphs,
        modelData
      );
      if (!isFitOngoing && !isLoopOngoing) {
        handleMultipleIdUpdate(idsToUpdate);
        updateChi2Terms();
      }

      setUpdatedModelFE_IDs([]);
    }
  }, [updatedModelFE_IDs]);

  const updateModelDataOnFileChange = () => {
    if (
      !modelData ||
      modelData.length === 0 ||
      !uploadedFiles ||
      uploadedFiles.length === 0
    ) {
      return;
    }

    try {
      const updatedModels = deepCopy(modelData);
      let modelUpdated = false;

      // Process model and submodels recursively
      const processModel = (model) => {
        // Check if model has dataFiles array
        if (hasProperty(model, "dataFiles") && model.dataFiles.length > 0) {
          const validDataFiles = [];
          let dataFilesChanged = false;

          // Process each entry in dataFiles
          model.dataFiles.forEach((dataFile) => {
            const file = uploadedFiles.find((f) => f.ID === dataFile.FE_ID);

            if (file) {
              // File exists - verify and update values if needed
              const correctNpoint = file.poinsInRange || file.npoints || 0;
              const correctDataRangeMin = file.dataRangeMin || 0;
              const correctDataRangeMax = file.dataRangeMax || 0;

              if (
                dataFile.npoint !== correctNpoint ||
                dataFile.dataRangeMin !== correctDataRangeMin ||
                dataFile.dataRangeMax !== correctDataRangeMax
              ) {
                // Values need updating
                validDataFiles.push({
                  FE_ID: dataFile.FE_ID,
                  npoint: correctNpoint,
                  dataRangeMin: correctDataRangeMin,
                  dataRangeMax: correctDataRangeMax,
                });
                dataFilesChanged = true;
                modelUpdated = true;
              } else {
                // Values are correct, keep the entry
                validDataFiles.push(dataFile);
              }
            } else {
              // File not found - remove from dataFiles and update parameter
              dataFilesChanged = true;
              modelUpdated = true;

              // Find and update the DataFile parameter that references this file
              if (
                hasProperty(model, "modelParams") &&
                model.modelParams.length > 0
              ) {
                model.modelParams.forEach((param) => {
                  if (
                    param.type === "DataFile" &&
                    param.value === dataFile.FE_ID &&
                    param.recuring === 0
                  ) {
                    param.value = -1;
                  }
                });
              }
            }
          });

          // Update dataFiles array if it changed
          if (dataFilesChanged) {
            model.dataFiles = validDataFiles;
          }
        }

        // Recursively process submodels
        if (hasProperty(model, "subModels") && model.subModels.length > 0) {
          model.subModels.forEach((subModel) => {
            processModel(subModel);
          });
        }
      };

      // Process all models
      updatedModels.forEach((model) => {
        processModel(model);
      });

      // Update modelData if any changes were made
      if (modelUpdated) {
        setModelData(updatedModels);
      }
    } catch (error) {
      recordedErrorLog("Error updating modelData on file change: ", error);
    }
  };

  const updateChi2Terms = () => {
    if (chi2Terms.length > 0 && selectedChi2Terms.length > 0) {
      const termsToSend = chi2Terms.filter((term) => {
        if (selectedChi2Terms.some((id) => id === term.id) && term.weight > 0) {
          return true;
        } else {
          return false;
        }
      });

      if (termsToSend.length > 0) {
        performChi2Message(
          termsToSend,
          modelData,
          uploadedFiles,
          sendJsonMessage,
          currentUser,
          recordedErrorLog,
          chi2ReqAllowed,
          setChi2ReqAllowed,
          chi2QueRef,
          setWarnings,
          setNewWarningCount,
          limitedToast
        );
      }
    }
  };

  const checkAndReportFileIdIssues = (localUploadedFiles) => {
    // Retrieve the session fileID from sessionStorage
    const sessionFileID = JSON.parse(window.sessionStorage.getItem("fileID"));

    // Ensure uploadedFiles is an array
    if (!Array.isArray(localUploadedFiles)) {
      limitedToast("CRITICAL ERROR! UploadedFiles is not a valid array.");
      generateWarningObject(
        "CRITICAL ERROR! UploadedFiles is not a valid array.",
        2,
        setWarnings,
        setNewWarningCount
      );
      return;
    }

    // Check for duplicate IDs
    const ids = localUploadedFiles.map((file) => file.ID);
    const uniqueIds = new Set(ids);
    if (ids.length !== uniqueIds.size) {
      limitedToast(
        "CRITICAL ERROR! Duplicate file ID detected in uploadedFiles."
      );
      generateWarningObject(
        "CRITICAL ERROR! Duplicate file ID detected in uploadedFiles. Please report to support how you ended up in this situation!",
        2,
        setWarnings,
        setNewWarningCount
      );
      return;
    }

    // Check that all file IDs are smaller than the session fileID
    const invalidFile = localUploadedFiles.find(
      (file) => file.ID >= sessionFileID
    );
    if (invalidFile) {
      // WARNING: Add your warning production code here for invalid file IDs.
      limitedToast(
        `File ID of ${invalidFile.name} is not smaller than session fileID (${sessionFileID}). Please report this to support!`
      );
      generateWarningObject(
        `File ID of ${invalidFile.name} is not smaller than session fileID (${sessionFileID}). Please report this to support!`,
        2,
        setWarnings,
        setNewWarningCount
      );
      return;
    }
  };

  const handleFilesUpdated = (localUploadedFiles) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      updateModelDataOnFileChange();
      updateChi2Terms();
      checkAndReportFileIdIssues(localUploadedFiles);
      debounceTimeoutRef.current = null;
    }, 800);
  };

  useEffect(() => {
    try {
      if (uploadedFiles.length > 0) {
        handleFilesUpdated(uploadedFiles);
      }
    } catch (error) {
      recordedErrorLog(
        "Error in handleFilesUpdated useEffect: ",
        error,
        true,
        "interface error",
        { uploadedFiles: uploadedFiles }
      );
    }
  }, [uploadedFiles]);

  useEffect(() => {
    try {
      if (lastJsonMessage) {
        if (hasProperty(lastJsonMessage, "Broadcast")) {
          setBroadcastMessage(lastJsonMessage.Broadcast);
          setBroadcastOpen(true);
          clearMessage();
        }
      }
    } catch (error) {
      recordedErrorLog(
        "Last Json message broadcast useEffect has failed: ",
        error
      );
    }
  }, [lastJsonMessage]);

  useEffect(() => {
    try {
      if (fileToChange !== null) {
        const foundFile = uploadedFiles.find(
          (uFile) => uFile.ID === fileToChange
        );
        if (foundFile !== undefined) {
          setFileToReprocess(foundFile);
          setReprocessOpen(true);
        }
      }
    } catch (error) {
      recordedErrorLog("'fileToChange' useEffect has failed: ", error);
    }
  }, [fileToChange]);

  useEffect(() => {
    fromGraph.current = false;
    setfromGraphState(false);
  }, [selectedFiles]);

  useEffect(() => {
    if (fileCallFromGraph && !fromGraph.current) {
      fromGraph.current = true;
      setfromGraphState(true);
    }
  }, [fileCallFromGraph]);

  useEffect(() => {
    if (fileCallFromGraph) {
      setFileCallFromGraph(false);
    }
  }, [fileCallFromGraph]);

  function resetSelection() {
    setSelectedFiles([]);
    fromGraph.current = false;
    setfromGraphState(false);
  }

  useEffect(() => {
    function handleMouseDownOutside(event) {
      if (
        !fromGraph.current &&
        dashboardRef.current &&
        isClickedOutside(event)
      ) {
        setSelectedFiles([]);
      }
    }

    document.addEventListener("mousedown", handleMouseDownOutside);

    return () => {
      document.removeEventListener("mousedown", handleMouseDownOutside);
    };
  }, [dashboardRef]);

  useEffect(() => {
    if (isAuthReady) {
      if (authToken === "") {
        navigate("/login");
      } else if (accessLevel < 1) {
        // Redirect users with access_level 0 back to profile page
        navigate("/profile");
      }
    }
  }, [isAuthReady, accessLevel]);

  useEffect(() => {
    if (ReadyState.OPEN === readyState && !authSent) {
      sendMessage("Token: " + authToken);
      setAuthSent(true);
    }
  }, [readyState]);

  useEffect(() => {
    if (lastMessage === "websocket connection autheticated") {
      setAuthConfirmed(true);
    }
  }, [lastMessage]);

  useEffect(() => {
    if (chi2ReqAllowed && Object.keys(chi2QueRef.current).length > 0) {
      let termsToSend = [];
      for (let i = 0; i < Object.keys(chi2QueRef.current).length; i++) {
        const term = chi2QueRef.current[Object.keys(chi2QueRef.current)[i]];
        termsToSend.push(term);
      }
      performChi2Message(
        termsToSend,
        modelData,
        uploadedFiles,
        sendJsonMessage,
        currentUser,
        recordedErrorLog,
        chi2ReqAllowed,
        setChi2ReqAllowed,
        chi2QueRef,
        setWarnings,
        setNewWarningCount,
        limitedToast
      );
    }
  }, [chi2ReqAllowed]);

  // We do this chi2 update here instead of in the fit, because it takes a bit of time to unlock the websocket
  // to allow other requests straight after fit.
  useEffect(() => {
    // if (updateChiTerms && chiTermsToUpdate.current.length > 0) {
    if (updateChiTerms) {
      if (selectedChi2Terms.length > 0) {
        const termsToSend = chi2Terms.filter((term) => {
          if (
            selectedChi2Terms.some((id) => id === term.id) &&
            term.weight > 0
          ) {
            return true;
          } else {
            return false;
          }
        });

        if (termsToSend.length > 0) {
          performChi2Message(
            termsToSend,
            modelData,
            uploadedFiles,
            sendJsonMessage,
            currentUser,
            recordedErrorLog,
            chi2ReqAllowed,
            setChi2ReqAllowed,
            chi2QueRef,
            setWarnings,
            setNewWarningCount,
            limitedToast
          );
        }
      }

      // chiTermsToUpdate.current = [];
      setUpdateChiTerms(false);
    }
  }, [updateChiTerms]);

  useEffect(() => {
    try {
      if (
        lastJsonMessage != null &&
        hasProperty(lastJsonMessage, "Error") &&
        lastJsonMessage.Error.length > 0
      ) {
        for (let i = 0; i < lastJsonMessage.Error.length; i++) {
          const error = lastJsonMessage.Error[i];
          const idRequest = hasProperty(lastJsonMessage, "requestID")
            ? lastJsonMessage.requestID
            : "none";
          limitedToast(error.message);
          generateWarningObject(
            error.message,
            2,
            setWarnings,
            setNewWarningCount,
            error.reportable,
            idRequest
          );
        }
        if (isFitOngoing) {
          setIsFitOngoing(false);
        }
      }
      if (
        lastJsonMessage != null &&
        hasProperty(lastJsonMessage, "Warning") &&
        lastJsonMessage.Warning.length > 0
      ) {
        for (let i = 0; i < lastJsonMessage.Warning.length; i++) {
          const warning = lastJsonMessage.Warning[i];
          limitedWarningToast(warning);
          generateWarningObject(warning, 1, setWarnings, setNewWarningCount);
        }
      }
    } catch (error) {
      recordedErrorLog("Error and Warning handling useEffect failure: ", error);
    }
  }, [lastJsonMessage]);

  function handleChi2Message(jsonMessage, fit = true) {
    const containsError =
      hasProperty(jsonMessage, "Error") && jsonMessage.Error.length > 0;
    if (
      fit &&
      (!hasProperty(jsonMessage, "Fit") ||
        !hasProperty(jsonMessage.Fit, "chi2") ||
        !hasProperty(jsonMessage.Fit.chi2, "chi2s") ||
        !hasProperty(jsonMessage.Fit.chi2, "nActiveParameters"))
    ) {
      if (!containsError) {
        recordedErrorLog(
          "No chi2 values found in the json message without error.",
          null,
          true,
          "Failed to obtain chi2 values.",
          {
            jsonMessage: jsonMessage,
          }
        );
      }
      return;
    }
    if (
      !fit &&
      (!hasProperty(jsonMessage, "Loop") ||
        !hasProperty(jsonMessage.Loop, "chi2") ||
        !hasProperty(jsonMessage.Loop.chi2, "chi2s") ||
        !hasProperty(jsonMessage.Loop.chi2, "nActiveParameters"))
    ) {
      if (!containsError) {
        recordedErrorLog(
          "No chi2 values found in the json message without error.",
          null,
          true,
          "Failed to obtain chi2 values.",
          {
            jsonMessage: jsonMessage,
          }
        );
      }
      return;
    }
    const newTerms = fit
      ? jsonMessage.Fit.chi2.chi2s
      : jsonMessage.Loop.chi2.chi2s;
    const newTotalAp = fit
      ? jsonMessage.Fit.chi2.nActiveParameters
      : jsonMessage.Loop.chi2.nActiveParameters;

    setTotalActiveParams(newTotalAp);

    const updatedTerms = updatedChi2(newTerms, chi2Terms);

    setChi2Terms(updatedTerms);
  }

  function handleVdfResponse(lastMessage, requestedVdfs) {
    const containsError =
      hasProperty(lastMessage, "Error") && lastMessage.Error.length > 0;
    if (
      !hasProperty(lastMessage, "Model") ||
      !hasProperty(lastMessage.Model, "SendModel") ||
      lastMessage.Model.SendModel.length === 0 ||
      lastMessage.Model.SendModel[0] === undefined ||
      lastMessage.Model.SendModel[0] === null
    ) {
      if (!containsError) {
        recordedErrorLog(
          "No model data found in the json message without error.",
          null,
          true,
          "Failed to obtain model data.",
          {
            jsonMessage: lastMessage,
          }
        );
      }
      return;
    }
    try {
      let modelsCopy = deepCopy(modelData);
      const requestedModelIDs = [];
      for (let i = 0; i < requestedVdfs.length; i++) {
        const requestedModelVDF = requestedVdfs[i];
        const foundVdf = lastMessage.Model.SendModel.find(
          (model) => model.modelid === requestedModelVDF.id
        );
        if (foundVdf !== null) {
          requestedModelIDs.push(requestedModelVDF.id);
          const modelToUpdate = deepCopy(
            getModelById(requestedModelVDF.id, modelsCopy)
          );

          modelToUpdate.vdfData = {
            ...modelToUpdate.vdfData,
            ...foundVdf.vdf,
          };
          if (hasProperty(requestedModelVDF, "gridData")) {
            modelToUpdate.vdfData.gridData = requestedModelVDF.gridData;
          }
          if (hasProperty(requestedModelVDF, "gridlinear")) {
            modelToUpdate.vdfData.gridlinear = requestedModelVDF.gridlinear;
          }

          modelsCopy = replaceModelById(
            modelsCopy,
            modelToUpdate,
            requestedModelVDF.id
          );
        } else {
          if (!containsError) {
            recordedErrorLog(
              "VDF requested but not received for: ",
              null,
              true,
              "Failed to obtain VDF.",
              {
                jsonMessage: lastMessage,
                requestedVdfs: requestedVdfs,
              }
            );
          }
        }
      }

      setModelData(modelsCopy);
      setUpdatedModelFE_IDs(requestedModelIDs);
    } catch (error) {
      recordedErrorLog("Vdf response handling error: ", error);
    }
  }

  useEffect(() => {
    try {
      if (lastJsonMessage) {
        const processingJsonMessage = deepCopy(lastJsonMessage);

        if (hasProperty(processingJsonMessage, "requestID")) {
          const requestData = retrieveRequestData(
            processingJsonMessage.requestID
          );
          if (requestData !== null) {
            switch (requestData.type) {
              case "chi2-message":
                handleChi2Message(processingJsonMessage);
                deleteRequestDataEntry(processingJsonMessage.requestID);
                setChi2ReqAllowed(true);
                break;
              case "vdf-request":
                handleVdfResponse(
                  processingJsonMessage,
                  requestData.requestedVdfs
                );
                deleteRequestDataEntry(processingJsonMessage.requestID);
                break;
              // case "binary-vdf-load":
              //   // handleVdfBinaryLoad(lastJsonMessage);
              //   handleVdfResponse(lastJsonMessage, requestData.requestedVdfs);
              //   deleteRequestDataEntry(lastJsonMessage.requestID);
              //   break;

              case "loop-request":
                // handleVdfBinaryLoad(lastJsonMessage);
                handleLoopResponse(processingJsonMessage);
                break;
              case "multiple-id-dist-update":
                handleMultiIdDistUpdate(processingJsonMessage);
                deleteRequestDataEntry(processingJsonMessage.requestID);
                break;
              case "autofit":
                monitorStateChange("autofit_completed", {
                  jsonMessage: processingJsonMessage,
                });
                handleFitResponse(processingJsonMessage, true);
                deleteRequestDataEntry(processingJsonMessage.requestID);
                break;
              case "fit-message":
                handleFitMessage(processingJsonMessage);
                break;
              default:
                break;
            }
          }
        } else {
          throw new Error("Request ID was not attached to the json message.");
        }
      }
    } catch (error) {
      recordedErrorLog(
        "Last Json message useEffect handler has failed: ",
        error
      );
    }
  }, [lastJsonMessage]);

  function handleMultiIdDistUpdate(
    jsonMessage,
    forFit = false,
    forLoop = false,
    isDone = false,
    graphs_input = null
  ) {
    try {
      // if (updatePending.current) {
      // We extract coordinate set from the message
      let remainingIDs = [...requestedFitModelsLocal.current];

      if (
        !hasProperty(jsonMessage, "Model") ||
        !hasProperty(jsonMessage.Model, "SendCurve") ||
        lastJsonMessage.Model.SendCurve.length === 0 ||
        lastJsonMessage.Model.SendCurve[0] === undefined ||
        lastJsonMessage.Model.SendCurve[0] === null
      ) {
        if (!hasProperty(jsonMessage, "Error") && !forFit && !forLoop) {
          recordedErrorLog(
            "No model curve found in the json message without error.",
            null,
            true,
            "Failed to obtain model curve.",
            {
              jsonMessage: jsonMessage,
            }
          );
        }
        if (!forFit && !forLoop) {
          updatePending.current = false;
        }
        return;
      }
      const coordSets = jsonMessage.Model.SendCurve;
      const dict = getReturnedCurveDictionaryByGraphId(coordSets);
      const graphIds = Object.keys(dict);
      let graphsCopy = graphs_input ? deepCopy(graphs_input) : deepCopy(graphs);

      // We loop through graphs in order to update them
      for (let i = 0; i < graphIds.length; i++) {
        if (parseInt(graphIds[i]) < 0) {
          continue; // these are for export curves requests, not for updating graphs
        }
        const currentGraphToUpdateIndex = graphsCopy.findIndex(
          (graph) => graph.id === parseInt(graphIds[i])
        );
        for (let j = 0; j < dict[graphIds[i]].length; j++) {
          const newCurve = dict[graphIds[i]][j];
          if (isDone) {
            remainingIDs = remainingIDs.filter(
              (id) =>
                id.modelId != newCurve.modelId &&
                id.quantity != newCurve.quantity
            );
          }
          graphsCopy[currentGraphToUpdateIndex].plotData = graphsCopy[
            currentGraphToUpdateIndex
          ].plotData.map((plot) => {
            if (
              hasProperty(plot, "modelId") &&
              plot.modelId === newCurve.modelId &&
              plot.quantity === newCurve.quantity
            ) {
              const xUnit = getQuantityXUnitFromModels(
                modelData,
                newCurve.modelId,
                newCurve.quantity
              );
              const convertedData = convertDataFromUnitsToUnits(
                xUnit,
                units[0],
                newCurve.coordinates,
                true
              );
              return {
                ...plot,
                x: convertedData.map((point) => point.x),
                y: convertedData.map((point) => point.y),
              };
            } else {
              return plot;
            }
          });
        }
      }
      setGraphs(graphsCopy);
      if (!forFit && !forLoop) {
        if (updateIDWaitList.current.length > 0) {
          // handle ids from wait list here
          handleMultipleIdUpdate(updateIDWaitList.current);
          updateIDWaitList.current = [];
        }
        // We reset the pending update flag to false
        // THIS DOES NOT GET RESET ALWAYS, MAINLY ON SLOW PCS
        updatePending.current = false;
      }
      if (forFit) {
        requestedFitModelsLocal.current = remainingIDs;
        setRequestedFitModel(requestedFitModelsLocal.current);
      }
      // }
    } catch (error) {
      recordedErrorLog(
        "Error handling new model curve response in handleMultiIdDistUpdate: ",
        error,
        true,
        "Failed to obtain model curve.",
        {
          jsonMessage: jsonMessage,
        }
      );
    }
  }

  const handleMultipleIdUpdate = (idList) => {
    if (idList.length > 0) {
      try {
        if (updatePending.current) {
          updateIDWaitList.current = [
            ...new Set([...updateIDWaitList.current, ...idList]),
          ];
        } else {
          // requestedModelsUpdate.current = idList;

          const rangesForModels = getRangesForModelsFromGraphs(graphs);

          const paramsForPayload = generateModelsRangesQuantPairsForModelDist(
            idList,
            rangesForModels,
            modelData
          );

          const payload = createModelDistPayload(
            paramsForPayload.models,
            rangesForModels,
            paramsForPayload.quantityPairs,
            currentUser,
            uploadedFiles
          );
          updatePending.current = true;
          sendJsonMessage(payload, { type: "multiple-id-dist-update" });
        }
      } catch (error) {
        recordedErrorLog("Multiple Id update failed: ", error);
      }
    }
  };

  const handleModelUpdateResponse = (response) => {
    let copyOfModels = deepCopy(modelData);
    let updateModels = false;

    // This variable will check if there are any strange values from the BE for parameters that are not used in FE
    // We are updating model parameters and curves separately, because when we make a fit request, more than
    // just requested curve model is returned - sub models don't necessarily require curve update, but their
    // parameter update needs to be taken into account

    // UPDATING MODEL PARAMETERS AND ROWS

    if (
      hasProperty(response, "Model") &&
      hasProperty(response.Model, "SendModel")
    ) {
      try {
        for (let i = 0; i < response.Model.SendModel.length; i++) {
          const modelDataFromResponse = response.Model.SendModel[i];

          if (!hasProperty(modelDataFromResponse, "modelid")) {
            recordedErrorLog(
              "Model data from response does not contain modelid: ",
              null,
              true,
              "Model update error.",
              {
                response: response,
              }
            );
            continue;
          }
          // Check if requested model is actually received
          updateModels = true;

          // Find the model which needs updating
          const modelToUpdate = deepCopy(
            getModelById(modelDataFromResponse.modelid, copyOfModels)
          );

          if (
            hasProperty(modelDataFromResponse, "vdf") &&
            hasProperty(modelToUpdate, "vdfData")
          ) {
            modelToUpdate.vdfData = {
              ...modelToUpdate.vdfData,
              ...modelDataFromResponse.vdf,
            };
          }

          if (
            hasProperty(modelDataFromResponse.parameters, "lineshapes") &&
            hasProperty(modelToUpdate, "lineshapeData") &&
            modelToUpdate.lineshapeData.length > 0
          ) {
            let newLineshapeData = modelDataFromResponse.parameters.lineshapes;
            for (let i = 0; i < newLineshapeData.length; i++) {
              let lineshapetype = newLineshapeData[i].shapes;
              let lineshape_index = modelToUpdate.lineshapeData.findIndex(
                (lineshape) =>
                  lineshape.lineshape_id === newLineshapeData[i].lineshape_id
              );
              if (
                lineshape_index === -1 ||
                lineshapetype.length !==
                  modelToUpdate.lineshapeData[lineshape_index].lineParams.length
              ) {
                recordedErrorLog(
                  "Lineshape response doesn't match model: ",
                  null,
                  true,
                  "Interface Error.",
                  {
                    modelToUpdate: modelToUpdate,
                    modelDataFromResponse: modelDataFromResponse,
                    lineshapeId: newLineshapeData[i].lineshape_id,
                  }
                );
                continue;
              }
              for (let j = 0; j < lineshapetype.length; j++) {
                for (let k = 0; k < lineshapetype[j].length; k++) {
                  let param_index =
                    hasProperty(
                      modelToUpdate.lineshapeData[lineshape_index],
                      "lineParams"
                    ) &&
                    modelToUpdate.lineshapeData[lineshape_index].lineParams
                      .length > j
                      ? modelToUpdate.lineshapeData[lineshape_index].lineParams[
                          j
                        ].findIndex(
                          (param) =>
                            param.speqqle_id === lineshapetype[j][k].speqqle_id
                        )
                      : -1;
                  if (param_index === -1) {
                    recordedErrorLog(
                      "Lineshape parameter not found in model: ",
                      null,
                      true,
                      "Interface Error.",
                      {
                        modelToUpdate: modelToUpdate,
                        modelDataFromResponse: modelDataFromResponse,
                        lineshapeId: newLineshapeData[i].lineshape_id,
                        lineshapeParamId: lineshapetype[j][k].speqqle_id,
                      }
                    );
                    continue;
                  }
                  modelToUpdate.lineshapeData[lineshape_index].lineParams[j][
                    param_index
                  ].value = lineshapetype[j][k].value;
                  modelToUpdate.lineshapeData[lineshape_index].lineTableRows[j][
                    modelToUpdate.lineshapeData[lineshape_index].lineParams[j][
                      param_index
                    ].name
                  ] = lineshapetype[j][k].value;
                  if (
                    hasProperty(
                      modelToUpdate.lineshapeData[lineshape_index].lineParams[
                        j
                      ][param_index],
                      "group"
                    )
                  ) {
                    const groupToUpdate =
                      modelToUpdate.lineshapeData[lineshape_index].lineParams[
                        j
                      ][param_index].group;

                    const updatedGroups = localValueGroups.current.map(
                      (group) => {
                        if (group.groupNumber === groupToUpdate) {
                          const maxVal =
                            group.hardMax < lineshapetype[j][k].value
                              ? null
                              : group.hardMax;
                          const minVal =
                            group.hardMin > lineshapetype[j][k].value
                              ? null
                              : group.hardMin;
                          return {
                            ...group,
                            value: lineshapetype[j][k].value,
                            hardMax: maxVal,
                            hardMin: minVal,
                          };
                        } else {
                          return group;
                        }
                      }
                    );
                    localValueGroups.current = updatedGroups;
                  }
                }
              }
            }
          }

          // Find non recuring params from model
          let nonRecParams = [];
          if (hasProperty(modelToUpdate, "modelParams")) {
            nonRecParams = modelToUpdate.modelParams.filter(
              (param) => param.recuring == 0
            );
          }

          // Get new parameters for the model, remove first entry, since it's not needed
          let modelParamsToUse = [];
          if (
            hasProperty(modelDataFromResponse, "parameters") &&
            hasProperty(modelDataFromResponse.parameters, "global")
          ) {
            modelParamsToUse = deepCopy(
              modelDataFromResponse.parameters.global
            );
            if (modelDataFromResponse.modeltype !== 0) {
              modelParamsToUse.shift(); // IF NOT A DL (Material) MODEL ONLY!
            }
          }

          let recParamsForUpdate = [];
          const hasRec =
            hasProperty(modelToUpdate, "recTemplate") &&
            hasProperty(modelToUpdate.recTemplate, "params") &&
            modelToUpdate.recTemplate.params.length > 0;

          // From a model recuring parameter template, get a parameter with a smallest speqqle id
          const smallestIDTemplateParam = hasRec
            ? modelToUpdate.recTemplate.params.reduce(
                (min, param) =>
                  min.speqqle_id < param.speqqle_id ? min : param,
                modelToUpdate.recTemplate.params[0]
              )
            : null;

          // In this array we will keep all the found parameters and we will use it to check which parameters
          // have not been used
          let allFoundParams = [];

          // Loop through all the new parameters to sort them
          for (let i = 0; i < modelParamsToUse.length; i++) {
            const modelParam = modelParamsToUse[i];
            // If new parameter matches non recuring parameter speqqle id, update the non recuring parameter
            if (
              nonRecParams.length > 0 &&
              nonRecParams.some(
                (param) => param.speqqle_id == modelParam.speqqle_id
              )
            ) {
              modelToUpdate.modelParams = modelToUpdate.modelParams.map(
                (param) => {
                  if (param.speqqle_id == modelParam.speqqle_id) {
                    return {
                      ...param,
                      value:
                        param.type !== "Checkbox"
                          ? modelParam.value
                          : checkBool(modelParam.value),
                    };
                  } else {
                    return param;
                  }
                }
              );

              // Add Non Recuring parameters to the list of found values
              allFoundParams.push(modelParam);
              for (let i = 0; i < modelToUpdate.modelParams.length; i++) {
                if (
                  modelToUpdate.modelParams[i].speqqle_id ===
                  modelParam.speqqle_id
                ) {
                  if (hasProperty(modelToUpdate.modelParams[i], "group")) {
                    const groupToUpdate = modelToUpdate.modelParams[i].group;
                    const updatedGroups = localValueGroups.current.map(
                      (group) => {
                        if (group.groupNumber === groupToUpdate) {
                          const maxVal =
                            group.hardMax < modelToUpdate.modelParams[i].value
                              ? null
                              : group.hardMax;
                          const minVal =
                            group.hardMin > modelToUpdate.modelParams[i].value
                              ? null
                              : group.hardMin;
                          return {
                            ...group,
                            value: modelToUpdate.modelParams[i].value,
                            hardMax: maxVal,
                            hardMin: minVal,
                          };
                        } else {
                          return group;
                        }
                      }
                    );
                    localValueGroups.current = updatedGroups;
                  }
                }
              }
            } else {
              // If it doesn't match, that means the new parameter is potentially a recuring one, add it to
              // possibly recuring parameter array if its speqqle id is equal or higher than the smallest template speqqle id
              // this prevents of adding values which are guaranteed unfit for the recuring parameters
              if (
                hasRec &&
                modelParam.speqqle_id >= smallestIDTemplateParam.speqqle_id
              ) {
                recParamsForUpdate.push(modelParam);
              }
            }
          }

          // The following actions are only relevant if model has recurring parameters
          if (hasRec) {
            // Find the new parameter with the largest speqqle id
            const paramForUpdateWithLargestID = recParamsForUpdate.reduce(
              (max, param) => (max.speqqle_id > param.speqqle_id ? max : param),
              recParamsForUpdate[0]
            );

            // Find the recuring parameter from a template with the largest speqqle id and recuring value combination for
            // given largest speqqle id of parameter for updating
            const largestIDModelTemplateParam =
              modelToUpdate.recTemplate.params.reduce(
                (max, param) =>
                  (paramForUpdateWithLargestID.speqqle_id - max.speqqle_id) /
                    max.recuring >
                  (paramForUpdateWithLargestID.speqqle_id - param.speqqle_id) /
                    param.recuring
                    ? max
                    : param,
                modelToUpdate.recTemplate.params[0]
              );

            // Calculate maximum possible recuring table rows
            const maxPossibleRows = Math.floor(
              (paramForUpdateWithLargestID.speqqle_id -
                largestIDModelTemplateParam.speqqle_id) /
                largestIDModelTemplateParam.recuring
            );

            let rowsOfValues = [];

            // Loop until max possible rows are reached, <= is used because we calculate rows from 0
            for (let row = 0; row <= maxPossibleRows; row++) {
              let values = [];
              // loop through template parameters to match each parameter with
              for (
                let paramIndex = 0;
                paramIndex < modelToUpdate.recTemplate.params.length;
                paramIndex++
              ) {
                // Find the value according to a parameter from the template
                const param = modelToUpdate.recTemplate.params[paramIndex];
                const foundValue = recParamsForUpdate.find(
                  (paramToUpdate) =>
                    paramToUpdate.speqqle_id ==
                    param.speqqle_id + row * param.recuring
                );
                // Add recuring parameters to the list of found values
                allFoundParams.push(foundValue);
                // If the value is found, push it to the value row
                if (foundValue != undefined) {
                  values.push({
                    value:
                      param.type !== "Checkbox"
                        ? foundValue.value
                        : checkBool(foundValue.value),
                    speqqle_id: param.speqqle_id,
                  });
                }
              }
              // Push the row of values to the array of rows
              rowsOfValues.push(values);
            }

            // Find all the unincluded parameters
            // Check if the last row is completely filled, if not, discard it
            if (
              rowsOfValues[rowsOfValues.length - 1].length !=
              modelToUpdate.recTemplate.params.length
            ) {
              rowsOfValues.pop();
            }

            // Loop through the array of new row values
            for (let rowIndex = 0; rowIndex < rowsOfValues.length; rowIndex++) {
              const rowValues = rowsOfValues[rowIndex];

              // Check if the row is in the recuring parameters table
              if (modelToUpdate.recParams.length > rowIndex) {
                // If the recuring parameters table contains this row, do the updates
                for (
                  let i = 0;
                  i < modelToUpdate.recParams[rowIndex].length;
                  i++
                ) {
                  // Find the value from row values that matches rec table parameter speqqle id
                  const foundVal = rowValues.find(
                    (rowVal) =>
                      rowVal.speqqle_id ==
                      modelToUpdate.recParams[rowIndex][i].speqqle_id
                  );

                  // If the value is found, update rec table parameter and row values
                  if (foundVal != undefined) {
                    if (
                      hasProperty(modelToUpdate.recParams[rowIndex][i], "group")
                    ) {
                      const groupToUpdate =
                        modelToUpdate.recParams[rowIndex][i].group;

                      const updatedGroups = localValueGroups.current.map(
                        (group) => {
                          if (group.groupNumber === groupToUpdate) {
                            const maxVal =
                              group.hardMax < foundVal.value
                                ? null
                                : group.hardMax;
                            const minVal =
                              group.hardMin > foundVal.value
                                ? null
                                : group.hardMin;
                            return {
                              ...group,
                              value: foundVal.value,
                              hardMax: maxVal,
                              hardMin: minVal,
                            };
                          } else {
                            return group;
                          }
                        }
                      );

                      localValueGroups.current = updatedGroups;
                    }

                    modelToUpdate.recParams[rowIndex][i] = {
                      ...modelToUpdate.recParams[rowIndex][i],
                      value: foundVal.value,
                    };

                    if (
                      checkIfSubModTitle(
                        modelToUpdate.recParams[rowIndex][i].name
                      )
                    ) {
                      const foundCorrectSubMod = modelToUpdate.subModels.find(
                        (subMod) => subMod.FE_ID === foundVal.value
                      );
                      modelToUpdate.recTableRows[rowIndex] = {
                        ...modelToUpdate.recTableRows[rowIndex],
                        [modelToUpdate.recParams[rowIndex][i].name]:
                          foundCorrectSubMod.displayName,
                      };
                    } else {
                      modelToUpdate.recTableRows[rowIndex] = {
                        ...modelToUpdate.recTableRows[rowIndex],
                        [modelToUpdate.recParams[rowIndex][i].name]:
                          foundVal.value,
                      };
                    }
                  }
                }
              } else {
                // THIS ELSE CODE IS ONLY RELEVANT FOR AUTOFIT, CURRENTLY AUTOFIT IS NOT AVAILABLE FOR MODELS WITH SUB
                // MODELS AND THEREFORE THAT CASE IS NOT SOLVED HERE. WILL NEED AN UPDATE IF THAT CHANGES LATER!!
                // If row index of new values is greater than current recuring parameter table lenght, that means we
                // need to add additional parameter row from template
                let paramRow = [];
                let tableRow = {};

                // Loop through recuring parameters template
                for (
                  let i = 0;
                  i < modelToUpdate.recTemplate.params.length;
                  i++
                ) {
                  // Find the value from values row that matches template parameter speqqle id
                  const foundVal = rowValues.find(
                    (rowVal) =>
                      rowVal.speqqle_id ==
                      modelToUpdate.recTemplate.params[i].speqqle_id
                  );
                  // If the value is found, add the paramter with value from row of values to temporary parameters
                  // If the value is not found, we still add entry to the table, but with value from the template - this
                  // prevents the creation of tables with undefined table cells
                  if (foundVal != undefined) {
                    paramRow.push({
                      ...modelToUpdate.recTemplate.params[i],
                      value: foundVal.value,
                    });
                    tableRow = {
                      ...tableRow,
                      [modelToUpdate.recTemplate.params[i].name]:
                        foundVal.value,
                    };
                  } else {
                    paramRow.push({
                      ...modelToUpdate.recTemplate.params[i],
                    });
                    tableRow = {
                      ...tableRow,
                      [modelToUpdate.recTemplate.params[i].name]:
                        modelToUpdate.recTemplate.params[i].value,
                    };
                  }
                }

                // When temporary recuring parameter and table row values are filled, update model with them
                modelToUpdate.recParams.push(paramRow);
                modelToUpdate.recTableRows.push(tableRow);
              }

              // Here we will check if there are any other rows remaining in the parameter table after we finished adding ones from BE. We will remove them if found
              if (rowIndex === rowsOfValues.length - 1) {
                modelToUpdate.recTableRows.splice(rowIndex + 1);
                modelToUpdate.recParams.splice(rowIndex + 1);
              }
            }
          }

          copyOfModels = replaceModelById(
            copyOfModels,
            modelToUpdate,
            modelDataFromResponse.modelid
          );
          if (!isDeepEqual(localValueGroups.current, valueGroups)) {
            setValueGroups(localValueGroups.current);
          }
        }
        if (updateModels) {
          setModelData(copyOfModels);
        }
      } catch (error) {
        recordedErrorLog(
          "There was an error retrieving model data from fit/loop message, message does not contain model data: ",
          error,
          true,
          "Failed to update model data.",
          {
            response: response,
          }
        );
      }
    }
  };

  const handleFitResponse = (response, isDone = true) => {
    if (hasProperty(response, "Error") && response.Error.length > 0) {
      requestedFitModelsLocal.current = [];
      setRequestedFitModel(requestedFitModelsLocal.current);
    } else if (requestedFitModelsLocal.current.length > 0) {
      // First lets update the chi2 terms
      try {
        handleChi2Message(response);
      } catch (error) {
        recordedErrorLog(
          "There was an error retrieving chi2 values from fit message: ",
          error
        );
      }

      try {
        //Updating edges of the file only relevevant for autofit
        const filesCopy = deepCopy(uploadedFiles);
        if (
          hasProperty(response, "Fit") &&
          hasProperty(response.Fit, "chi2") &&
          hasProperty(response.Fit.chi2, "chi2s")
        ) {
          for (let i = 0; i < response.Fit.chi2.chi2s.length; i++) {
            const chi2 = response.Fit.chi2.chi2s[i];
            if (hasProperty(chi2, "autofitedge")) {
              for (let j = 0; j < filesCopy.length; j++) {
                if (filesCopy[j].ID === chi2.DataID) {
                  const maxFromFit = chi2.autofitedge[1];
                  const minFromFit = chi2.autofitedge[0];
                  console.log(
                    "filesCopy[j].edges",
                    deepCopy(filesCopy[j].edges)
                  );
                  if (
                    !filesCopy[j].edges.some(
                      (edge) =>
                        edge.min === minFromFit &&
                        edge.max === maxFromFit &&
                        edge.unit.value === units[0].value
                    )
                  ) {
                    filesCopy[j].edges.push({
                      min: minFromFit,
                      max: maxFromFit,
                      unit: units[0],
                    });
                    filesCopy[j].edges = filesCopy[j].edges.filter(
                      (edge) => edge.min !== "" && edge.max !== ""
                    );
                  }
                  console.log(
                    "filesCopy[j].edges",
                    deepCopy(filesCopy[j].edges)
                  );
                }
              }
            }
          }
          //Files edges updated from autofit, we can update the files now.
          if (!isDeepEqual(filesCopy, uploadedFiles)) {
            setUploadedFiles(filesCopy);
          }
        }
      } catch (error) {
        recordedErrorLog(
          "There was an error updating files edges from fit message: ",
          error,
          true,
          "Failed to update autofit  exclusion ranges.",
          {
            response: response,
          }
        );
      }
      handleModelUpdateResponse(response);
      handleMultiIdDistUpdate(response, true, false, isDone);
    }
  };

  function handleFitMessage(jsonMessage) {
    try {
      if (hasProperty(jsonMessage, "Error") && jsonMessage.Error.length > 0) {
        setUpdateChiTerms(true);
        setIsFitOngoing(false);
        setFitIteration(null);
        deleteRequestDataEntry(lastJsonMessage.requestID);
      } else {
        if (!hasProperty(jsonMessage, "Fit")) {
          recordedErrorLog(
            "Fit message does not contain Fit section.",
            null,
            false,
            "Failed to update fit results.",
            {
              jsonMessage: jsonMessage,
            }
          );
          setUpdateChiTerms(true);
          setIsFitOngoing(false);
          setFitIteration(null);
          deleteRequestDataEntry(lastJsonMessage.requestID);
          return;
        }
        const fitSection = jsonMessage.Fit;
        if (hasProperty(fitSection, "fitactive")) {
          setIsFitOngoing(false);
          setFitIteration(null);
          deleteRequestDataEntry(lastJsonMessage.requestID);
        } else if (
          hasProperty(fitSection, "fit") &&
          hasProperty(fitSection.fit, "fit_done") &&
          fitSection.fit.fit_done
        ) {
          const fitStatus = fitSection.fit;
          handleFitResponse(jsonMessage, true);
          setUpdateChiTerms(true);
          setIsFitOngoing(false);
          setFitIteration(null);
          limitedSucessToast(
            `The fit was finished succesfully with ${fitStatus.n_iterations} iterations.`
          );
          deleteRequestDataEntry(lastJsonMessage.requestID);
        } else {
          const fitStatus = fitSection.fit;
          setFitIteration(fitStatus.n_iterations);
          handleFitResponse(jsonMessage, false);

          if (
            hasProperty(fitSection, "chi2") &&
            hasProperty(fitSection.chi2, "chi2s")
          ) {
            const newTerms = fitSection.chi2.chi2s;
            const updatedTerms = updatedChi2(newTerms, chi2Terms);
            setChi2Terms(updatedTerms);
          }
        }
      }
    } catch (error) {
      const requestData = retrieveRequestData(lastJsonMessage.requestID);
      if (requestData) {
        deleteRequestDataEntry(lastJsonMessage.requestID);
      }
      recordedErrorLog(
        "Error handling Fit message: ",
        error,
        true,
        "Failed to update fit results.",
        {
          jsonMessage: jsonMessage,
        }
      );
      //deleteRequestDataEntry(lastJsonMessage.requestID);
    }
  }

  const handleLoopResponse = (lastJsonMessage) => {
    const containsError =
      hasProperty(lastJsonMessage, "Error") && lastJsonMessage.Error.length > 0;
    if (
      !hasProperty(lastJsonMessage, "Loop") &&
      !hasProperty(lastJsonMessage, "Fit")
    ) {
      if (!containsError) {
        recordedErrorLog(
          "No loop data found in the json message without error.",
          null,
          true,
          "Failed to obtain loop data.",
          {
            jsonMessage: lastJsonMessage,
          }
        );
      }
      return;
    }
    try {
      // We check if this is standard message or the one idetifying end of Loop
      if (hasProperty(lastJsonMessage, "Loop")) {
        //HERE WE HANDLE CHI2 UPDATES

        if (pauseOnNextLoop) {
          setLoopPaused(true);
        }

        handleChi2Message(lastJsonMessage, false);

        //We make a copy of models to keep updating single array

        //Here we deal with curve updates
        handleModelUpdateResponse(lastJsonMessage);
        let graphsCopy = deepCopy(graphs);
        if (
          hasProperty(lastJsonMessage.Loop, "AccumulatedOutputs") &&
          hasProperty(lastJsonMessage.Loop.AccumulatedOutputs, "Variables") &&
          lastJsonMessage.Loop.AccumulatedOutputs.Variables.length > 0
        ) {
          try {
            // Create one graph per parameter
            let currentGraphId = graphId;

            // Calculate the left panel width dynamically
            const calculateLeftPanelWidth = () => {
              // Material-UI Grid uses 12 columns, left panel takes remaining space after graph (xs=5) and right panel
              // Assuming right panel takes similar space, left panel gets the remainder
              const totalWidth = window.innerWidth;
              const graphWidth = totalWidth * (5 / 12); // Graph takes 5/12 of width
              const rightPanelWidth = totalWidth * (3.5 / 12); // Estimate right panel width
              const leftPanelWidth = totalWidth - graphWidth - rightPanelWidth;
              return Math.max(leftPanelWidth, 200); // Minimum 200px
            };

            const leftPanelWidth = calculateLeftPanelWidth();

            lastJsonMessage.Loop.AccumulatedOutputs.Variables.forEach(
              (variable, index) => {
                const variableModel = trackedParameters.find(
                  (model) => model.FE_ID === variable.modelid
                );

                // Get the actual model to get the model name
                const actualModel = getModelById(variable.modelid, modelData);
                const modelName = actualModel
                  ? actualModel.displayName
                  : "Unknown Model";

                const parameterDetails = variableModel.selectedParams.find(
                  (param) => {
                    if (param.lineshape_id !== null) {
                      return (
                        param.lineshape_id === variable.lineshape_id &&
                        param.rowIndex === variable.row_index &&
                        param.speqqle_id === variable.speqqle_id
                      );
                    } else if (param.rowIndex !== null) {
                      return (
                        param.speqqle_id + param.rowIndex * param.recuring ===
                        variable.speqqle_id
                      );
                    } else {
                      return param.speqqle_id === variable.speqqle_id;
                    }
                  }
                );

                // Get the actual parameter name from the model
                let paramName = "Unknown Parameter";

                if (actualModel && parameterDetails) {
                  if (parameterDetails.lineshape_id !== null) {
                    // Lineshape parameter
                    const lineshape = actualModel.lineshapeData?.find(
                      (ls) => ls.lineshape_id === parameterDetails.lineshape_id
                    );
                    if (
                      lineshape &&
                      lineshape.lineParams?.[parameterDetails.rowIndex]
                    ) {
                      const param = lineshape.lineParams[
                        parameterDetails.rowIndex
                      ].find(
                        (p) => p.speqqle_id === parameterDetails.speqqle_id
                      );
                      if (param) {
                        paramName = param.name;
                      }
                    }
                  } else if (parameterDetails.rowIndex !== null) {
                    // Recurring parameter
                    const recParam =
                      actualModel.recParams?.[parameterDetails.rowIndex];
                    if (recParam) {
                      const param = recParam.find(
                        (p) => p.speqqle_id === parameterDetails.speqqle_id
                      );
                      if (param) {
                        paramName = param.name;
                      }
                    }
                  } else {
                    // Non-recurring parameter
                    const param = actualModel.modelParams?.find(
                      (p) => p.speqqle_id === parameterDetails.speqqle_id
                    );
                    if (param) {
                      paramName = param.name;
                    }
                  }
                }

                // Create full title using the complete model name
                // Format the parameter name to handle Greek letters and symbols
                // Use FormattedText function, then convert HTML to simple string

                const formattedParamName = formatParamNameToString(paramName);
                let plotTitle = `${formattedParamName}`;
                if (parameterDetails.rowIndex !== null) {
                  plotTitle =
                    plotTitle + `; Row ${parameterDetails.rowIndex + 1}`;
                }
                const shortTitle = `Batch: ${modelName}`; // Short title for display
                const uniqueIdentifier = `${modelName}-${formattedParamName}-${
                  parameterDetails.rowIndex || 0
                }-${parameterDetails.lineshape_id || 0}`; // Unique identifier

                const varId = `${variable.modelid}|${variable.speqqle_id}`;
                const lineColor = getColor(index);

                // Create plot data for this single parameter
                const xValues = variable.Output.map((point) => point.x);
                const yValues = variable.Output.map((point) => point.y);

                // Calculate the actual range from the data
                const maxX = Math.max(...xValues);
                const minX = Math.min(...xValues);

                const plotData = [
                  {
                    line: { color: lineColor },
                    variableId: varId,
                    mode: "lines+markers",
                    name: plotTitle,
                    legendgroup: plotTitle,
                    type: "scattergl",
                    x: xValues,
                    y: yValues,
                  },
                ];

                // Check if a graph for this parameter already exists
                const existingGraphIndex = graphsCopy.findIndex(
                  (graph) =>
                    graph.type === "loop-variable-tracking" &&
                    hasProperty(graph, "uniqueIdentifier") &&
                    graph.uniqueIdentifier === uniqueIdentifier
                );

                if (existingGraphIndex !== -1) {
                  // Update existing graph
                  graphsCopy[existingGraphIndex] = {
                    ...graphsCopy[existingGraphIndex],
                    plotData: plotData,
                    layout: {
                      ...graphsCopy[existingGraphIndex].layout,
                      xaxis: {
                        ...graphsCopy[existingGraphIndex].layout.xaxis,
                        range: [Math.max(0, minX - 0.5), maxX + 0.5],
                      },
                    },
                    // Preserve the size property to prevent graph from resizing
                    size: graphsCopy[existingGraphIndex].size,
                  };
                } else {
                  // Create new graph for this parameter
                  const newGraphId = currentGraphId;
                  currentGraphId++;

                  const newGraph = {
                    ...DEFAULT_GRAPH,
                    id: newGraphId,
                    type: "loop-variable-tracking",
                    plotData: plotData,
                    title: shortTitle, // Short title for display
                    uniqueIdentifier: uniqueIdentifier, // Unique identifier for graph management
                    position: {
                      x: -(leftPanelWidth / 2) + Math.floor(index / 2) * 450, // Start at left panel width (left of graph area) and offset each graph by 100px horizontally
                      y: 0 + (index % 2) * 350, // Offset each graph by 100px vertically (remainder for grid)
                    },
                    size: {
                      width: Math.max(window.innerWidth * 0.25, 200), // Smaller window width
                      height: Math.max(window.innerWidth * 0.2, 180), // Smaller window height
                    },
                    layout: {
                      ...DEFAULT_GRAPH.layout,
                      // Remove width and height from layout to prevent conflicts with window size
                      width: undefined,
                      height: undefined,
                      showlegend: true, // Force legend to show even with single trace
                      legend: {
                        ...DEFAULT_GRAPH.layout.legend,
                        visible: true, // Ensure legend is visible
                      },
                      xaxis: {
                        ...DEFAULT_GRAPH.layout.xaxis,
                        title: { text: "Iteration" },
                        range: [Math.max(0, minX - 0.5), maxX + 0.5],
                        hideUnits: true, // Hide units for non-standard graphs
                      },
                      yaxis: {
                        ...DEFAULT_GRAPH.layout.yaxis,
                        title: { text: "Value" },
                        hideUnits: true, // Hide units for non-standard graphs
                      },
                    },
                  };
                  graphsCopy.unshift(newGraph);

                  setZIndices((prevZIndices) => {
                    return {
                      ...prevZIndices,
                      [newGraphId]: Object.keys(prevZIndices).length,
                    };
                  });
                }
              }
            );

            // Update the global graphId after processing all variables
            setGraphId(currentGraphId);
          } catch (error) {
            recordedErrorLog(
              "Error processing AccumulatedOutputs in loop response: ",
              error,
              true,
              "Loop Response Error",
              {
                lastJsonMessage: lastJsonMessage,
                trackedParameters: trackedParameters,
                graphsCopy: graphsCopy,
              }
            );
            limitedWarningToast(
              "Error processing batch variable tracking data."
            );
          }
        }
        if (
          hasProperty(lastJsonMessage, "Model") &&
          hasProperty(lastJsonMessage.Model, "SendCurve") &&
          lastJsonMessage.Model.SendCurve.length > 0
        ) {
          handleMultiIdDistUpdate(
            lastJsonMessage,
            false,
            true,
            false,
            graphsCopy
          );
        } else {
          setGraphs(graphsCopy);
        }
        //Here we handle with users request to save MODELS into files
        const modelsThatNeedSaving = listOfLoopModelsToSave.filter(
          (model) => model.save
        );
        if (modelsThatNeedSaving.length > 0) {
          for (let i = 0; i < modelsThatNeedSaving.length; i++) {
            const modelToSave = modelsThatNeedSaving[i];

            const relevantModelFromResponse =
              lastJsonMessage.Model.SendModel.find(
                (modelFromResponse) =>
                  modelFromResponse.modelid === modelToSave.FE_ID
              );

            if (relevantModelFromResponse) {
              downloadStringTxtFile(
                JSON.stringify(relevantModelFromResponse),
                `${loopModelFilesCustomName}_${modelToSave.name}_Iteration_${lastJsonMessage.Loop.current_loop_iteration}`,
                ".spqm"
              );
            } else {
              console.warn("No loop model found to save.");
            }
          }
        }
        //Here we handle with users request to save CURVES into files

        if (listOfLoopCurvesToSave.length > 0) {
          for (let i = 0; i < listOfLoopCurvesToSave.length; i++) {
            const curveToSave = listOfLoopCurvesToSave[i];
            let curveFound = false;

             const possibleCurves = lastJsonMessage.Model.SendCurve.filter(
              (curveSet) => {
                const xUnit = getQuantityXUnitFromModels(
                  modelData,
                  curveSet.modelid,
                  curveSet.curves[0].quantity
                );
                return (
                  curveSet.graphId === -1 &&
                  curveSet.modelid === curveToSave.modelId &&
                  curveSet.curves[0].quantity === curveToSave.quantity &&
                  curveSet.isInverseUnit === (isInverseUnit(curveToSave.unit) !== isInverseUnit(xUnit)) &&
                  curveSet.isLogarithmic === curveToSave.log &&
                  curveSet.curves[0].coordinates.length === curveToSave.nPoints
                );
              }
            );
            if (possibleCurves.length > 0) {
              let bestMatchIndex = -1;
              let bestMatchDistance = Infinity;
              for (let i = 0; i < possibleCurves.length; i++) {
                const xUnit = getQuantityXUnitFromModels(
                  modelData,
                  possibleCurves[i].modelid,
                  possibleCurves[i].curves[0].quantity
                );
                const convertedData = convertDataFromUnitsToUnits(
                  xUnit,
                  curveToSave.unit,
                  possibleCurves[i].curves[0].coordinates,
                  true
                );
                const distance =
                  Math.abs(convertedData[0].x - curveToSave.min) +
                  Math.abs(
                    convertedData[convertedData.length - 1].x - curveToSave.max
                  );
                if (distance < bestMatchDistance) {
                  bestMatchDistance = distance;
                  bestMatchIndex = i;
                }
              }
              if (
                bestMatchIndex !== -1 &&
                bestMatchDistance <
                  (curveToSave.max - curveToSave.min) / curveToSave.nPoints
              ) {
                curveFound = true;
                const bestMatch = possibleCurves[bestMatchIndex];
                const xUnit = getQuantityXUnitFromModels(
                  modelData,
                  bestMatch.modelid,
                  bestMatch.curves[0].quantity
                );
                const convertedData = convertDataFromUnitsToUnits(
                  xUnit,
                  curveToSave.unit,
                  bestMatch.curves[0].coordinates,
                  true
                );
                let unitValue = curveToSave.unit?.value || "cm^-1";

                // Convert quantity name to string if it's JSX
                let quantityNameStr = "";
                let quantityName = getQuantityNameFromModels(
                  modelData,
                  curveToSave.modelId,
                  curveToSave.quantity
                );
                if (quantityName) {
                  if (typeof quantityName === "string") {
                    quantityNameStr = quantityName;
                  } else {
                    // It's JSX, convert to HTML string then extract text
                    quantityNameStr = jsxToHtmlString(quantityName);
                    // Remove HTML tags for plain text file
                    quantityNameStr = quantityNameStr.replace(/<[^>]*>/g, "");
                  }
                }

                // Create header row
                const headerRow = `${unitValue}\t${quantityNameStr}`;

                const stringifiedData = convertedData.map(
                  (point) => `${point.x}\t${point.y}`
                );
                const singleString = [headerRow, ...stringifiedData].join("\n");

                downloadStringTxtFile(
                  singleString,
                  `${curveToSave.name}_Iteration_${lastJsonMessage.Loop.current_loop_iteration}`
                );
                continue;
              }
            }
            if (!curveFound) {
              recordedErrorLog(
                "Requested curve not found in response: ",
                null,
                true,
                "Loop Curve Export Error: requested curve not found",
                {
                  curveToSave: curveToSave,
                  lastJsonMessage: lastJsonMessage,
                }
              );
            }
          }
        }

        //Here we finish up with loop handling and check if it is done. If so, we reset relevant variables, otherwise, we
        //update iteration count
        if (lastJsonMessage.Loop.loop_done) {
          setLoopPaused(false);
          setPauseOnNextLoop(false);
          setIsLoopOngoing(false);
          setLoopIteration(null);
          deleteRequestDataEntry(lastJsonMessage.requestID);
        } else {
          setLoopIteration(lastJsonMessage.Loop.current_loop_iteration);
        }
      } else {
        if (
          hasProperty(lastJsonMessage, "Fit") &&
          hasProperty(lastJsonMessage.Fit, "fitactive") &&
          !lastJsonMessage.Fit.fitactive
        ) {
          setIsLoopOngoing(false);
          setLoopIteration(null);
          deleteRequestDataEntry(lastJsonMessage.requestID);
        }
      }
    } catch (error) {
      recordedErrorLog("Error handling loop response: ", error);
    }
  };

  const handleCloseIconClick = () => {
    setBroadcastOpen(false);
  };

  const handleReprocessClose = () => {
    setReprocessOpen(false);
    setFileToReprocess(null);
    setFileToChange(null);
  };

  const handleReprocessDone = (newFile) => {
    try {
      const updatedFiles = uploadedFiles.map((uFile) => {
        if (uFile.ID === newFile.ID) {
          return newFile;
        } else {
          return uFile;
        }
      });

      setUploadedFiles(updatedFiles);

      handleReprocessClose();
    } catch (error) {
      recordedErrorLog("Reprocess done handler failure: ", error);
    }
  };

  const handleFitStop = () => {
    sendJsonMessage(
      {
        User: currentUser.id,
        stopfit: true,
      },
      false
    );
    limitedSucessToast(`The fit was stopped after ${fitIteration} iterations.`);
    generateWarningObject(
      `The fit was stopped after ${fitIteration} iterations.`,
      0,
      setWarnings,
      setNewWarningCount
    );
    setIsFitOngoing(false);
    setFitIteration(null);
  };

  const handleLoopStop = () => {
    sendJsonMessage(
      {
        User: currentUser.id,
        stop_task: true,
      },
      false
    );

    setLoopPaused(false);
    setPauseOnNextLoop(false);
  };

  const handleLoopStep = () => {
    sendJsonMessage(
      {
        User: currentUser.id,
        pause_next_iteration: true,
      },
      false
    );
    setLoopPaused(false);
    setPauseOnNextLoop(true);
  };

  const handleLoopRun = () => {
    sendJsonMessage(
      {
        User: currentUser.id,
        stop_pause: true,
      },
      false
    );
    setLoopPaused(false);
    setPauseOnNextLoop(false);
  };

  return (
    <Box sx={{ display: "flex" }} ref={dashboardRef}>
      <Box
        component="main"
        id="main-dashboard-container"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 3,
          height: "100vh",
          overflow: "scroll",
          width: 1,
        }}
      >
        <AppBar />
        <WindowSelector />
        <Container maxWidth={false} disableGutters className="mainContainer">
          <Grid
            container
            spacing={0.5}
            sx={{ mt: 0, marginTop: "0.5vh", flexWrap: "nowrap" }}
            className="gridContainer"
            style={{ position: "relative", zIndex: "5" }}
          >
            <DndProvider backend={HTML5Backend}>
              {parametersOpen && (
                <GridViewIcon
                  className={`paramSortedIcon${
                    areParamsSorted ? " active" : ""
                  }`}
                  onClick={() => {
                    setAreParamsSorted((old) => {
                      const newVal = !old;
                      if (newVal) {
                        setCheckParamPositions(true);
                      }
                      return newVal;
                    });
                  }}
                />
              )}
              {/* dashboard is divided by 3 grids 
                First grid = data loading, data settings, models */}
              {/* {showLeftPanel ? <LeftSide /> : <></>} */}
              <LeftSide />
              {/* Second grid = graph */}
              <Grid item xs={5}>
                {outputsOpen ? <GraphContainer /> : <></>}
                {loopOpen ? <Loop /> : <></>}
              </Grid>
              {/* Third grid = fit results, params table, warnings and export (all imported components) */}
              {/* <RightSide setShowOtherPanel={setShowLeftPanel} /> */}
              <RightSide />
            </DndProvider>
          </Grid>
          {/* imported Copyright component */}
          <div className="copyright">
            <Copyright sx={{ pb: 4 }} />
          </div>
        </Container>
        {isFitOngoing && (
          <FitStopWindow
            iterationCount={fitIteration}
            handleStop={handleFitStop}
          />
        )}
        {isLoopOngoing && (
          <LoopStopWindow
            iterationCount={loopIteration}
            handleStop={handleLoopStop}
            handleLoopStep={handleLoopStep}
            handleLoopRun={handleLoopRun}
            paused={loopPaused}
          />
        )}
      </Box>
      {selectedFiles !== undefined && selectedFiles.length == 1 ? (
        <StickyFileWindow
          selectedFiles={selectedFiles}
          updateSelected={updateSelected}
          callFromGraph={fromGraphState}
          resetSelection={resetSelection}
        />
      ) : (
        <></>
      )}
      <BroadcastModal
        elementRef={dashboardRef}
        isOpen={broadcastOpen}
        setIsOpen={setBroadcastOpen}
        handleClose={handleCloseIconClick}
      />
      <Modal
        isOpen={reprocessOpen}
        onRequestClose={handleReprocessClose}
        shouldCloseOnOverlayClick={true}
        contentLabel="File Re-Processing Modal"
        appElement={dashboardRef.current}
        id="fileReProcessModal"
        style={{
          content: {
            width: "80vw",
            height: "70vh",
            top: `10%`,
            left: "10%",
            right: "auto",
          },
          overlay: {
            zIndex: "8000",
          },
        }}
      >
        <SingleFileReprocess
          file={fileToReprocess}
          handleDone={handleReprocessDone}
          handleCancel={handleReprocessClose}
          modalId={"fileReProcessModal"}
        />
      </Modal>
    </Box>
  );
}
